import { render, staticRenderFns } from "./CmgRecentAndFavoriteOrdersToggle.vue?vue&type=template&id=a59edc0c&scoped=true&lang=pug"
import script from "./cmg-recent-and-favorite-orders-toggle.ts?vue&type=script&lang=ts&external"
export * from "./cmg-recent-and-favorite-orders-toggle.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRecentAndFavoriteOrdersToggle.vue?vue&type=style&index=0&id=a59edc0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59edc0c",
  null
  
)

export default component.exports